import * as THREE from "three";
import Experience from "../Experience.js";

export default class Environment {
  constructor() {
    this.experience = new Experience();
    this.scene = this.experience.scene;
    this.resources = this.experience.resources;
    this.debug = this.experience.debug;

    // Ocean-like background and fog
    this.scene.background = new THREE.Color(2 / 255, 2 / 255, 3 / 255); // Dark ocean color
    this.scene.fog = new THREE.Fog(
      new THREE.Color(130 / 255, 175 / 255, 195 / 255),
      2,
      10
    ); // Light ocean fog

    this.setSunLight();
    this.setAmbientLight();

    this.debug.ui
      .addColor(this.scene, "background")
      .name("Background Color")
      .listen();
  }
  setAmbientLight() {
    this.ambientLight = new THREE.AmbientLight("#ffffff", 3.0);
    this.scene.add(this.ambientLight);
  }

  setSunLight() {
    this.sunLight = new THREE.DirectionalLight("#ffffff", 2);
    this.sunLight.castShadow = true;
    this.sunLight.shadow.camera.far = 15;
    this.sunLight.shadow.mapSize.set(1024, 1024);
    this.sunLight.shadow.normalBias = 0.05;
    this.sunLight.position.set(3.5, 2, 10.25);
    this.scene.add(this.sunLight);
  }
}
